export default __webpack_public_path__ + "static/media/rewards-icon.7a3e4c69.svg";